<!--
Displays a UoG logo banner.
Usage: <Logo />
@author bmk11u, crm4f
-->
<template>
  <header>
    <div class="headerContainer" :style="imageUrl != null ? `background-image: url('${imageUrl}')` : { 'background-color': bannerColour }">
      <div id="logo" style="width:50%" :style="imageUrl == null ? { 'background-color': bannerColour } : null">
        <img src="@/assets/UofG_App_Logo.svg" id="marque" alt="University of Glasgow Logo" height="110px"/>
      </div>
      <div class="notiContainer">
        <span v-if="props.showNotif" v-on:click="go('/notifications')" id="notiSpan">
          <img v-if="props.unreadNum!=0" id="bellNotiImg" src="@/assets/noti-bell.svg" alt="Notifications - unread notifications"/>
          <img v-else id="bellImg" src="@/assets/bell.svg" alt="Notifications - no unread notifications"/>
        </span>
        <p id="welcome" v-if="props.showWelcome">Welcome, {{ props.name }}</p>
      </div>
    </div>
    <div v-if="bannerImage != null" class="bannerImage" :style="`background-image:url('${bannerImage}')`"></div>
  </header>
</template>

<script setup>
import * as lst from '@/components/localStorage.js'
import axios from 'axios'
import { onMounted, ref, defineProps} from 'vue'
import { useRouter } from 'vue-router'

const router = useRouter()
const props = defineProps(['unreadNum', 'showNotif', 'showWelcome', 'name'])

/* these values were present in the old options API component? they're not used? 
const hasBookingAccess = ref(lst.getValue('hasBookingAccess'))
const showPopupStudySpace = ref(lst.getValue('showPopupStudySpace'))
const hasChanges = ref(lst.getValue('hasChanges'))
*/
const authenticated = ref(lst.getValue('authenticated'))
const imageUrl = ref(null)
const bannerImage = ref(null)
const bannerColour = ref('#011451')
const currentAppTheme = ref(1)

onMounted(() => {
  // but don't do this if we're called in an unauthenticated context plz
  if (isTrue(authenticated.value)) {
    getCurrentAppTheme()
  }
})

function isTrue(val) {
  let ret = false
  if (val == true || val == 'true') {
    ret = true
  }
  return ret
}

function getCurrentAppTheme() {
  axios.get('/timetable/banners/category/42', {})
    .then(response => {
      // get the app-wide theme id
      let banners = response.data.banners
      if (typeof banners !== 'undefined' && banners.length > 0) {
        currentAppTheme.value = banners[0].content
        getBannerColour()
        getBannerImage()
      }
    })
    .catch((error) => {
      console.log(error)
    })
}

function getBannerColour () {
  axios.get('/timetable/theme/element/' + currentAppTheme.value + '/colour', {})
    .then(response => {
      // take one banner and display it
      let colour = response.data
      if (colour == "") {
        bannerColour.value = "#011451"
      } else {
        // check if the colour is actually an image
        if (colour.elementValue.indexOf('#') == 0) {
          bannerColour.value = colour.elementValue
        } else { // if it doesnt start with #, it must be an image.
          imageUrl.value = colour.elementValue
        }
        
      }
    })
    .catch((error) => {
      console.log(error)
    })
}

function isValidUrl(urlString) {
  let url
  
  try {
    url = new URL(urlString)
  } catch (_) {
    return false; 
  }

  return url.protocol === "http:" || url.protocol === "https:"
}

function getBannerImage () {
  axios.get('/timetable/theme/element/' + currentAppTheme.value + '/banner', {})
    .then(response => {
      // take one banner and display it
      let image = response.data
      if (image != "" && isValidUrl(image.elementValue)) {
        bannerImage.value = image.elementValue
      }
    })
    .catch((error) => {
      console.log(error)
    })
}

function go (path) {
  router.push(path)
}
</script>

<style scoped lang="scss">
.bannerImage {
  width: 100%;
  background-size: contain;
  height: 30px;
}

.headerContainer {
  display: flex;
  /* Status bar height on iOS 11.0 */
  padding-top: constant(safe-area-inset-top);
  /* Status bar height on iOS 11+ */
  padding-top: env(safe-area-inset-top);
  background-size: contain;
}

.notiContainer {
  padding-right: 15px;
  margin: 3px;
  width: 50%;
  display: flex;
  flex-flow: column wrap;
  justify-content: flex-end;
}

#notiSpan {
  float: right;
  text-align: end;
  margin-bottom: 20px;
  margin-left: 20px;
  margin-top: 40px;
}

#p {
  float:left;
}

#logo {
  height: 130px;
  /* Status bar height on iOS 10 */
  padding-top: 20px;
  position: relative;
  bottom: 0;
}

#marque {
  /*padding: 25px 0 25px 25px;*/
  width: 110px;
  height: auto;
 padding: 0;
 position: absolute;
 bottom: 0;
 /*svg */
  width: 110px;
  height: 110px;
  padding: 10px 29px;
}

#welcome {
  text-align:right;
  color:white;
  margin-bottom: 3px !important;
  font-weight: bold;
}

#bellImg {
  width: 20px;
  height: 23px;
  cursor: pointer;
}

#bellNotiImg {
  width: 23px;
  height: 28px;
  cursor: pointer;
}

</style>
